export const BanknoteAndArrow20Icon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path
          d="M0.833496 7.53544C0.833496 7.53544 4.3784 6.46009 6.66683 6.70211C9.49282 7.00097 10.4918 9.61076 13.3335 9.61877C15.7525 9.62559 19.1668 7.53544 19.1668 7.53544V17.5354C19.1668 17.5354 15.7025 19.235 13.3335 19.2021C10.5532 19.1635 9.43748 16.9363 6.66683 16.7021C4.37382 16.5083 0.833496 17.5354 0.833496 17.5354V7.53544Z"
          strokeWidth="1.67"
        />
        <ellipse
          cx="10.0002"
          cy="13.3333"
          rx="1.66667"
          ry="1.66667"
          strokeWidth="1.67"
        />
        <path
          d="M5.8335 10.8334C5.8335 7.50004 8.16683 3.33337 15.8335 3.33337M14.1668 0.833374L16.6668 3.33337L14.1668 5.83337"
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
